import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  roles: Role[];
  users: User[];
  userCount: number;
  user?: User | null;
}

const initialState: UserState = {
  roles: [],
  users: [],
  userCount: 0,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setRoles: (state, { payload }: PayloadAction<Role[]>) => {
      state.roles = payload;
    },
    setUser: (state, { payload }: PayloadAction<User | null | undefined>) => {
      state.user = payload;
    },
    setUserCount: (state, { payload }: PayloadAction<number>) => {
      state.userCount = payload;
    },
    setUsers: (state, { payload }: PayloadAction<User[]>) => {
      state.users = payload;
    },
  }
})

export const { setRoles, setUser, setUserCount, setUsers } = userSlice.actions;
export default userSlice.reducer;